<template>
    <div>
        <div v-for="(format, id) in model.resourceTypes" :key="id">
            <div v-if="format.items.length > 1">
                <div class="accordion box p-4 d-block col-12" :data-accordion-id="format.formatName">
                    <div class="accordion-header d-flex">
                        <div class="d-flex align-items-center">
                            <img :src="`/img/${format.formatName.toUpperCase()}.png`" />
                            <h6 class="m-0">
                                <a v-if="format.anchor" :id="format.anchor"></a>
                                {{ format.formatName }}
                            </h6>
                        </div>
                        <span v-if="accordionOpen != format.formatName" :aria-label="model.accordionOpen" tabindex="0" @keyup.enter="openAccordion(format.formatName)" @click="openAccordion(format.formatName)">
                            <svg class="icon icon-hsy-icon-plus-bold">
                                <use xlink:href="#icon-hsy-icon-plus-bold"></use>
                            </svg>
                        </span>
                        <span v-if="accordionOpen == format.formatName" class="close-accordion" :aria-label="model.accordionClose" tabindex="0" @keyup.enter="closeAccordion(id)" @click="closeAccordion(id)">
                            <svg class="icon icon-hsy-icon-minus-bold">
                                <use xlink:href="#icon-hsy-icon-minus-bold"></use>
                            </svg>
                        </span>
                    </div>
                    <transition name="slide">
                        <div v-if="accordionOpen == format.formatName" class="accordion-body mt-3">
                            <div v-for="(item, id) in format.items" :key="id" class="file-link">
                                <img :src="`/img/${format.formatName.toUpperCase()}.png`" />
                                <a :href="item.url">{{item.name}}</a>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <div v-else>
                <a v-for="(file, id) in format.items" :href="file.url" :key="id" class="link-box p-4">
                    <div class="d-flex align-items-center file-download">
                        <img :src="`/img/${format.formatName.toUpperCase()}.png`" />
                        <span class="h6 my-0">{{format.formatName}}</span>
                    </div>
                    <span class="gray-icon">
                        <svg class="icon icon-hsy-icon-download-bold">
                            <use xlink:href="#icon-hsy-icon-download-bold"></use>
                        </svg>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        computed: mapState({
            accordionOpen: state => state.accordionOpen
        }),
        methods: {
            openAccordion(id) {
                this.$store.commit("openAccordion", id);
            },
            closeAccordion(id) {
                this.$store.commit("closeAccordion", id);
            }
        }
    }
</script>